<template>
  <div v-if="showSpinner" class="overlay z-i-10">
    <div class="spinner"></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Spinner",
  computed: {
    ...mapGetters("spinner", {
      showSpinner: "loading"
    })
  }
};
</script>

<style lang="scss" scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: black;
  opacity: 0.33;
}
.spinner {
  display: inline-block;
  width: 64px;
  height: 64px;
}
.spinner:after {
  content: " ";
  display: block;
  width: 46px;
  height: 46px;
  margin: 1px;
  border-radius: 50%;
  border: 5px solid #fff;
  border-color: #fff transparent #fff transparent;
  animation: spinner 1s ease infinite;
}
@keyframes spinner {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
